import { render, staticRenderFns } from "./SimuladorField.vue?vue&type=template&id=2965d7f5&scoped=true"
import script from "./SimuladorField.vue?vue&type=script&lang=js"
export * from "./SimuladorField.vue?vue&type=script&lang=js"
import style0 from "./SimuladorField.vue?vue&type=style&index=0&id=2965d7f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2965d7f5",
  null
  
)

export default component.exports